/**
 * @generated SignedSource<<180c252f7f9faddc3a2a1a438688c909>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileEdition_authenticationConfig",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileEditionForm_authenticationConfig"
    }
  ],
  "type": "AuthenticationConfig",
  "abstractKey": null
};

node.hash = "780b296d2b1f99b622a169b83f92cec5";

module.exports = node;
